import { normalizeProgress as e, progressClassNames as t } from "../progress/progress-state.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import i from "clsx";
//#region src/components/status-icons/ProgressRing.tsx
var a = ({ value: a, label: o, valueText: s, max: c = 100, status: l = "active", size: u = 16, className: d, ...f }) => {
	let { current: p, maximum: m, percentage: h } = e(a, c, l);
	return /* @__PURE__ */ r("svg", {
		...f,
		width: f.width ?? u,
		height: f.height ?? u,
		viewBox: "0 0 16 16",
		fill: "none",
		role: "progressbar",
		"aria-label": o,
		"aria-valuemin": 0,
		"aria-valuemax": m,
		"aria-valuenow": p ?? void 0,
		"aria-valuetext": s,
		"data-task-status": l,
		className: i("pf:inline-block pf:shrink-0", t[l], d),
		children: [/* @__PURE__ */ n("circle", {
			cx: "8",
			cy: "8",
			r: "6.3",
			strokeWidth: "1.5",
			className: "pf:stroke-soft-pearl-700 pf:opacity-[0.35]"
		}), /* @__PURE__ */ n("circle", {
			cx: "8",
			cy: "8",
			r: "6.3",
			stroke: "currentColor",
			strokeWidth: "1.5",
			pathLength: "100",
			strokeDasharray: `${String(h ?? 30)} 100`,
			className: i("pf:-rotate-90 pf:origin-center pf:transition-[stroke-dasharray] pf:duration-(--pf-spring-smooth-duration) pf:ease-(--pf-easing-out) pf:motion-reduce:transition-none", p === null && l === "active" && "pf:animate-[pf-control-spin_600ms_linear_infinite] ")
		})]
	});
};
//#endregion
export { a as ProgressRing };
